import { createAction, props } from '@ngrx/store';
import { GetSecurityOutput } from '@smash-sdk/iam/ejs/11-2023/types/GetSecurity/GetSecurity';
import { UpdateSecurityOutput } from '@smash-sdk/iam/ejs/11-2023/types/UpdateSecurity/UpdateSecurity';
import { UpdateSecurityInput } from '@smash-sdk/iam/ejs/11-2023/types/UpdateSecurity/UpdateSecurity';

export const GetSecurity = createAction(
  '[Security] Get Security'
);

export const GetSecuritySuccess = createAction(
  '[Security] Get Security Success',
  props<{ security: GetSecurityOutput['security'] }>()
);

export const GetSecurityFailure = createAction(
  '[Security] Get Security Failure',
  props<{ error: any }>()
);

export const UpdateUserSecurity = createAction(
  '[Security] Update User Security',
  props<{ securityToUpdate: UpdateSecurityInput }>()
);

export const UpdateUserSecuritySuccess = createAction(
  '[Security] Update User Security Success',
  props<UpdateSecurityOutput>()
);

export const UpdateUserSecurityFailure = createAction(
  '[Security] Update User Security Failure',
  props<{ error: any }>()
);
